export default __webpack_public_path__ + "static/media/annal-logo.baf2caad.svg";